import { render, staticRenderFns } from "./VHoursWeek.vue?vue&type=template&id=47c1d964&"
import script from "./VHoursWeek.vue?vue&type=script&lang=js&"
export * from "./VHoursWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports